module.exports = __webpack_public_path__ + "static/media/logo-wordmark-white.47eafc57.png";